/**
 * Anzeigen von Popups
 * @class service_v3sPopupService
 * @memberOf v3sWbtPlayerApp:page:popup
 */
angular.module('v3sWbtPlayerApp').factory('v3sPopupService', ["$rootScope", "$modal", "$document", "$injector", "$timeout", "v3sServiceFinder", function ($rootScope, $modal, $document, $injector, $timeout, v3sServiceFinder) {
    var v3sGsapService = v3sServiceFinder.get("v3sGsapService");

    var popups = [];
    var popuptypes = [];
    var actor = null;
    var pageviewDraggable = null;
    var modal;
    var unbindShowHandler = null;
    var unbindHideHandler = null;
    var firefoxTimeout = null;

    /**
     * Fügt ein Popup dem Service hinzu
     * @param {object} popupObj
     */
    function addPopup(popupObj) {
        popups[popupObj.id] = popupObj;
    }

    /**
     * Setzt den Type des jeweiligen Popups
     */
    function setPopupType(id,type) {
        popuptypes[id] = type;
    }
    /**
     * Gibt den Typ eines Popups zurück
     * @param {string} popupid
     * @returns {string} type - Der Typ des Popups
     */
    function getType(popupid) {
        if (popupid.split(";").length > 1) {
            return "carousel";
        } else {
            if (!!popuptypes[popupid]) {
                return popuptypes[popupid];
            }
        }
    }

    /**
     * Positioniert das Popup und zeigt es dann an
     * @param {string} popupids - id des Popups oder semikolon-separierter String mit mehreren Popupids
     * @param {object} actor - Element an dem der Event gebunden ist, der das Popup öffnet
     */
    function show(popupids, actor) {

        if (!!firefoxTimeout) return;

        if (!!modal) {
            destroy();
        }
        if (v3sGsapService) {
            pageviewDraggable = v3sGsapService.getDraggable(document.querySelector("#page-view"));
            pageviewDraggable.disable();
        }

        var idsArray = popupids.split(";");

        var popupsToShow = [];

        angular.forEach(idsArray, function (id) {
            popupsToShow.push(popups[id.trim()]);
        });

        var isCarousel = idsArray.length > 1 || !actor || popupsToShow[0].isCarousel;

        //Die Optionen für den modal
        var options = {
            templateUrl: "app/js/page/popup/v3sPopup.tpl.html",
            locals: {
                popups: popupsToShow,
                isCarousel: isCarousel,
                actor: actor
            },
            html: true,
            viewport: "#wbt-view",
            backdropAnimation: !isCarousel ? "v3s-tooltip" : "v3s-carousel",
            container: "#wbtContent",
            bindToController: true,
            controller: ["popups", "isCarousel", "actor", function (popups, isCarousel, actor) {
            }],
            controllerAs: "ctrl",
            prefixEvent: (isCarousel) ? 'carousel' : 'popup',
            show: false
        };

        //Modal erstellen
        modal = $modal(options);
        //Modal rendern und Events binden
        modal.$promise.then(function () {

            /**
             * Firefox triggert den MouseEnter Event 2mal
             * Deswegen muss hier kurz gewartet werden, damit der mit dem ersten
             * mousenter event erstellte modal nicht sofort wieder zerstört wird.
             */
            firefoxTimeout = $timeout(function () {
                //onShow handler binden
                unbindShowHandler = $rootScope.$on(options.prefixEvent + ".show", onShowHandler);

                //Aufräumen
                unbindHideHandler = $rootScope.$on(options.prefixEvent + ".hide", function () {
                    if (!!modal) {
                        modal.destroy();
                        modal = null;
                        unbindShowHandler();
                        unbindHideHandler();
                        unbindHideHandler = unbindShowHandler = null;
                        if (pageviewDraggable) pageviewDraggable.enable();
                    }
                });
                firefoxTimeout = null;

                //Click auf den etwas anderes als das Tooltip soll den Tooltip schließen
                if (!isCarousel) {
                    $document.find("body").one("click", function (evt) {
                        hide();
                        evt.preventDefault();
                        evt.stopPropagation();
                    });
                }

                modal.show();
            }, 150);
        });
    }


    /**
     * Der Handler für den onShow-Event des Modals
     * @param {object} evt - das Event-Objekt
     * @param {object} themodal - Das Object des modals
     */
    function onShowHandler(evt, themodal) {
        //Das Popup-Element
        //Dieses Element wird platziert und evtl dimensioniert
        //var popupEl = angular.element(themodal.$element[0].querySelector('.v3s-popup'));
        var popupEl = themodal.$element;

        //HACK
        //v3sHypertextService wird schon in v3sAnimationService injected
        //-> Darum würde die normale injection zu einer circular injection führen
        //Die Hypertexte müssen aber nochmals erstellt werden, da die Direktive schon
        //beim Laden der Seite die Hypetexte erstellt. Jedoch für das ursprüngliche Element.


        var hypertexts = popupEl.find("v3s-hypertext");
        if (!!hypertexts.length > 0) {
            var v3sHypertextService = $injector.get("v3sHypertextService");
            angular.forEach(hypertexts, function (ht) {
                ht = angular.element(ht);
                v3sHypertextService.createLinkOnClick(
                    ht,
                    {
                        itemId: ht.attr("v3s-itemid"),
                        popupId: ht.attr("v3s-refid"),
                        filePath: ht.attr("v3s-file"),
                        url: ht.attr("v3s-url"),
                        entry: ht.attr("v3s-entry")
                    },
                    themodal.$scope,
                    null,
                    false);

            });
        }
        //Die Dimensionen des Popups, wenn es gerendert ist
        var dimensions = {
            height: popupEl.prop('offsetHeight'),
            width: popupEl.prop('offsetWidth')
        };

        //Freien Platz finden auf der Seite
        if (popupEl.hasClass('v3s-tooltip')) {
            var openspaces = getOpenSpaces(dimensions, themodal.$options.locals.actor);

            //Platzieren des Popups
            applyPlacement(openspaces, dimensions, themodal.$options.locals.actor, popupEl);
        }


        //Anzeigen des Popups
        popupEl.css("visibility", "visible");
    }

    /**
     * Platziert das Popup
     * @param {object} openspaces - die vier Bereiche, an dem das Popup positioniert werden kann
     * @param {object} dimensions - die Dimensionen des gerenderten Popups
     * @param {object} actor - Element an dem der Event gebunden ist, der das Popup öffnet
     * @param {object} popupEl - Popup DOM-Element
     */
    function applyPlacement(openspaces, dimensions, actor, popupEl) {

        //Offsets des actor-elements
        var actorOffset = getActorOffsets(actor);

        var navbarHeight = document.querySelector(".secondary-nav").offsetHeight || 50;

        var placement = {
            top: {},
            bottom: {},
            left: {},
            right:{}
        };
        var place = null;

        //Abstand zwischen actor und popup
        var gap = 5;

        /**
         * Testen ob das gerenderte Popup in einen der designierten Bereich passen würde,
         * ohne das Popup zu manipulieren
         * Reihenfolge:
         * Oben > Unten > Rechts > Links
         *
         * Wenn das Popup in den Bereich passt, wird getest, ob man das Popup an einer Kante
         * des actors ausrichten kann
         *
         */
        if (openspaces.top.height >= dimensions.height && openspaces.top.width >= dimensions.width) {

            popupEl.addClass("v3s-popup-top");
            place = "top";
            placement[place].bottom = popupEl.parent().prop('offsetHeight') - actorOffset.top + gap + "px";

            //Linke Kante
            if (openspaces.top.width - actorOffset.left >= dimensions.width) {
                placement[place].left = actorOffset.left + "px";

            //Rechte Kante
            } else if(actorOffset.left + actorOffset.width >= dimensions.width){
                placement[place].right = openspaces.top.width - (actorOffset.left + actorOffset.width) + "px";

                //Zentrieren
            } else {
                popupEl.css("width", dimensions.width + "px");
                popupEl.addClass("v3s-popup-center-horizontal");
            }
        }else if(openspaces.bottom.height >= dimensions.height && openspaces.bottom.width >= dimensions.width) {

            popupEl.addClass("v3s-popup-bottom");

            place = "bottom";

            placement[place].top = actorOffset.top + actorOffset.height + gap + "px";
            //Linke Kante
            if (openspaces.bottom.width - actorOffset.left >= dimensions.width) {
                placement[place].left = actorOffset.left + "px";

            //Rechte Kante
            } else if(actorOffset.left + actorOffset.width >= dimensions.width){
                placement[place].right = openspaces.bottom.width - (actorOffset.left + actorOffset.width) + "px";

            //Zentrieren
            } else {
                popupEl.css("width", dimensions.width + "px");
                popupEl.addClass("v3s-popup-center-horizontal");
            }

        }else if(openspaces.right.height >= dimensions.height && openspaces.right.width >= dimensions.width) {

            popupEl.addClass("v3s-popup-right");

            place = "right";
            placement[place].left = actorOffset.left + actorOffset.width + gap + "px";
            //Obere Kante
            if (openspaces.right.height - actorOffset.top >= dimensions.height) {
                placement[place].top = actorOffset.top + "px";

            //Zentrieren
            }else{
                popupEl.addClass("v3s-popup-center-vertical");
            }

        }else if(openspaces.left.height >= dimensions.height && openspaces.left.width >= dimensions.width) {

            popupEl.addClass("v3s-popup-left");

            place = "left";

            placement[place].left = actorOffset.left - dimensions.width - gap + "px";
            //Obere Kante
            if (openspaces.left.height - actorOffset.top >= dimensions.height) {
                placement[place].top = actorOffset.top + "px";

                //Zentrieren
            }else{
                popupEl.addClass("v3s-popup-center-vertical");
            }

            //Einpassen in den größten Bereich
        } else {
            var biggestspace = 0;
            var biggestspacename;
            var currSpace = 0;
            angular.forEach(openspaces, function (os, key) {
                currSpace = os.width * os.height;
                if (currSpace > biggestspace) {
                    biggestspace = currSpace;
                    biggestspacename = key;
                }
            });

            var popupHasFixedWidth = (popupEl.hasClass("v3s-fixed-width"));
            var popupHasFixedHeight = (popupEl.hasClass("v3s-fixed-height"));

            //Breiteanpassen - falls keine Breite angegeben
            var popupWidth = parseInt(popupEl.css('width')) || 0;
            if (!popupHasFixedWidth && dimensions.width >= openspaces[biggestspacename].width) {
                popupEl.css("width", openspaces[biggestspacename].width + "px");
            }

            //Neue höhe verwenden
            popupEl[0].querySelector(".v3s-popup-tooltip-content").style.overflowY = "scroll";
            var popupHeight = popupEl.prop("offsetHeight") + 6;//overflow:auto aktiviert den scrollbalken ein wenig "zu früh", darum werden 6px zur höhe hinzugefügt...
            popupEl[0].querySelector(".v3s-popup-tooltip-content").style.overflowY = "";

            if (!popupHasFixedHeight && popupHeight >= openspaces[biggestspacename].height) {
                popupEl.css("height", openspaces[biggestspacename].height + "px");
            } else {
                popupEl.css("height", popupHeight + "px");
            }

            var biggestSpaceIsLeftOrRight = (biggestspacename == "left" || biggestspacename == "right");
            var biggestSpaceIsTopOrBottom = (biggestspacename == "top" || biggestspacename == "bottom");
            var popupIsWiderThanSpace = (popupWidth > openspaces[biggestspacename].width);
            var popupIsHigherThanSpace = (popupHeight > openspaces[biggestspacename].height);

            if (popupHasFixedWidth && biggestSpaceIsLeftOrRight && popupIsWiderThanSpace) {
                place = biggestspacename;
                placement[biggestspacename][biggestspacename] = gap + "px";
                popupEl.addClass("v3s-popup-center-vertical");
            } else if (popupHasFixedHeight && biggestSpaceIsTopOrBottom && popupIsHigherThanSpace) {
                place = biggestspacename;

                //Navbar unten aussparen
                if (biggestspacename == "bottom") {
                    placement[biggestspacename][biggestspacename] = gap + navbarHeight + "px";
                } else {
                    placement[biggestspacename][biggestspacename] = gap + "px";
                }

                popupEl.addClass("v3s-popup-center-horizontal");
            } else {
                //Position neben dem Button :)
                switch (biggestspacename) {
                    case "top":
                        place = "top";
                        placement[place]["bottom"] = popupEl.parent().prop('offsetHeight') - actorOffset.top + "px";
                        popupEl.addClass("v3s-popup-top v3s-popup-center-horizontal");
                        break;
                    case "bottom":
                        place = "bottom";
                        placement[place]["top"] = actorOffset.top + actorOffset.height + "px";
                        popupEl.addClass("v3s-popup-bottom v3s-popup-center-horizontal");
                        break;
                    case "right":
                        place = "right";
                        placement[place]["left"] = actorOffset.left + actorOffset.width + "px";
                        popupEl.addClass("v3s-popup-right v3s-popup-center-vertical");
                        break;
                    case "left":
                        place = "left";
                        placement[place]["left"] = actorOffset.left - popupEl.prop("offsetWidth") + "px";
                        popupEl.addClass("v3s-popup-left v3s-popup-center-vertical");
                        break;
                    default:
                        break;
                }

            }
            //Klasse setzen
            popupEl.addClass("v3s-popup-fixed-dimensions");
        }

        if(!!place) popupEl.css(placement[place]);
    }

    /**
     * Berechnet die offsets des ActorElements
     * @param {object} actor - Element an dem der Event gebunden ist, der das Popup öffnet
     * @returns {object} actorOffset
     */
    function getActorOffsets(actor){
        var parentEl = angular.element($document[0].querySelector("v3s-document"));
        var actorOffset = {};
        actorOffset.left = actor[0].getBoundingClientRect().left - parentEl[0].getBoundingClientRect().left;
        actorOffset.top = actor[0].getBoundingClientRect().top - parentEl[0].getBoundingClientRect().top;
        actorOffset.width = actor.prop('offsetWidth');
        actorOffset.height = actor.prop('offsetHeight');

        return actorOffset;
    }

    /**
     * Errechnet die verfügbaren Bereiche für das Popup
     * @param {object} dimensions - Die Dimensionen des Popups
     * @param {object} actor - Element an dem der Event gebunden ist, der das Popup öffnet
     */
    function getOpenSpaces(dimensions, actor) {
        var parentEl = angular.element($document[0].querySelector("v3s-document"));
        var actorOffset = getActorOffsets(actor);

        //Find open Spaces
        var spaces = {
            top: {
                top: 0,
                left: 0,
                bottom: "auto",
                right: "auto",
                height: actorOffset.top,
                width: parentEl.prop("offsetWidth")
            },
            bottom: {
                top: "auto",
                left: 0,
                bottom: 0,
                right: "auto",
                height: parentEl.prop("offsetHeight") - (actorOffset.top + actor.prop("offsetHeight")),
                width: parentEl.prop("offsetWidth")
            },
            left: {
                top: 0,
                left: 0,
                bottom: "auto",
                right: "auto",
                height: parentEl.prop("offsetHeight"),
                width: actorOffset.left
            },
            right: {
                top: 0,
                left: "auto",
                bottom: "auto",
                right: 0,
                height: parentEl.prop("offsetHeight"),
                width: (parentEl.prop("offsetWidth")) - (actorOffset.left + actor.prop("offsetWidth"))
            }
        };

        return spaces;
    }

    function hide() {
        if (!!modal) {
            modal.hide();
        }
    }

    function destroy() {
        if (!!modal) {
            modal.hide();
            unbindShowHandler();
            unbindHideHandler();
            modal = null;
        }
    }

    return {
        addPopup : addPopup,
        setPopupType : setPopupType,
        getType: getType,
        show: show,
        hide : hide,
        destroy : destroy
    };

}]);
